'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Actions


// Components


// Constants


// Util


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _sharingPopupActions = require('../sharingPopupActions');

var _navigationActions = require('../../../../../reducers/navigationActions');

var _Icon = require('../../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _UserAvatar = require('../../../../../components/userAvatar/UserAvatar');

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _UserName = require('../../../../../components/userAvatar/UserName');

var _UserName2 = _interopRequireDefault(_UserName);

var _userConstants = require('../../../../../../common/users/userConstants');

var _permissionUtil = require('../../../../../../common/permissions/permissionUtil');

require('./UserAccessEntry.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RemoveIcon = function RemoveIcon(_ref) {
    var dispatchRemoveSharedUser = _ref.dispatchRemoveSharedUser;
    return _react2.default.createElement(
        'div',
        { className: 'remove-icon', onClick: dispatchRemoveSharedUser },
        _react2.default.createElement(_Icon2.default, { name: 'close-x' })
    );
};

RemoveIcon.propTypes = {
    dispatchRemoveSharedUser: _propTypes2.default.func
};

var UserStatus = function UserStatus(props) {
    var permission = props.permission,
        user = props.user,
        isCurrentUser = props.isCurrentUser,
        editable = props.editable,
        sharedBoard = props.sharedBoard;


    if ((0, _permissionUtil.isOwner)(permission)) return _react2.default.createElement(
        'span',
        { className: 'status' },
        'Owner'
    );
    if (isCurrentUser) return _react2.default.createElement('span', { className: 'status' });

    if (!editable) {
        if (sharedBoard && sharedBoard.get('elementType') === 'BOARD') {
            return _react2.default.createElement(
                'span',
                { className: 'status shared-board' },
                _react2.default.createElement(
                    'span',
                    null,
                    'Sharing\xA0'
                ),
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/' + sharedBoard.get('id') },
                    sharedBoard.getIn(['content', 'title'])
                )
            );
        }

        return _react2.default.createElement('span', { className: 'status' });
    }

    if (user && user.get('status') !== _userConstants.USER_STATUSES.ACTIVE) {
        return _react2.default.createElement(
            'span',
            { className: 'status invited' },
            _react2.default.createElement(
                'span',
                { className: 'status-text' },
                'Invite sent'
            ),
            _react2.default.createElement(RemoveIcon, props)
        );
    }

    return _react2.default.createElement(RemoveIcon, props);
};

UserStatus.propTypes = {
    user: _propTypes2.default.object,
    permission: _propTypes2.default.number,
    isCurrentUser: _propTypes2.default.bool,
    editable: _propTypes2.default.bool,
    currentlyViewing: _propTypes2.default.bool,
    sharedBoard: _propTypes2.default.object,
    navigateToSharedBoard: _propTypes2.default.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        dispatchRemoveSharedUser: function dispatchRemoveSharedUser() {
            return dispatch((0, _sharingPopupActions.removeSharedUser)({ elementId: ownProps.currentBoardId, userId: ownProps.userId }));
        },
        navigateToSharedBoard: function navigateToSharedBoard() {
            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: ownProps.sharedBoard.get('id') }));
        }
    };
};

var UserAccessEntry = function UserAccessEntry(props) {
    var currentlyViewing = props.currentlyViewing;


    var classes = (0, _classnames2.default)('UserAccessEntry', {
        'currently-viewing': currentlyViewing
    });

    return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
            'div',
            { className: 'details' },
            _react2.default.createElement(_UserAvatar2.default, _extends({}, props, { active: currentlyViewing })),
            _react2.default.createElement(_UserName2.default, props),
            _react2.default.createElement(UserStatus, props)
        )
    );
};

UserAccessEntry.propTypes = {
    user: _propTypes2.default.object.isRequired,
    name: _propTypes2.default.string,
    isCurrentUser: _propTypes2.default.bool,
    permission: _propTypes2.default.number.isRequired,
    editable: _propTypes2.default.bool,
    currentBoardId: _propTypes2.default.string,
    dispatchRemoveSharedUser: _propTypes2.default.func,
    currentlyViewing: _propTypes2.default.bool,
    online: _propTypes2.default.bool,
    sharedBoard: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(UserAccessEntry);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/userAccessList/UserAccessEntry.js
// module id = 2197
// module chunks = 0